<template>
  <div class="expense-entry-page pharmacy-expense-entry-page">

    <div class="expense-entry-heading">
      <div class="expense-entry-heading__icon" aria-hidden="true"><i class="fas fa-edit"></i></div>
      <div><span>Keuangan apotek</span><h1>Ubah pengeluaran apotek</h1><p>Perbarui informasi transaksi operasional apotek.</p></div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <Card :card-class="'expense-entry-card'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'pharmacy-expenses/' + form.id"
            />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import Form from '@/component/pharmacy/pharmacy-expenses/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        date: '',
        name: '',
        ammount: '',
        pharmacy_expense_category_id: '',
        notes: '',
        photo: [],
        photo_name: ''
      },
    }
  },

  methods: {

    async get() {
      this.form = await module.get('pharmacy-expenses/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/pharmacy/pharmacy-expenses/list')
      } else {
        this.form['_method'] = "put"
        this.form.photo_name = this.form.photo
        this.form.pharmacy_expense_category_id = 0
        this.form.photo = []
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Apotek", route:"/pharmacy/dashboard" },
      { title: "Pengeluaran", route: '/pharmacy/pharmacy-expenses/list' },
      { title: 'Edit Pengeluaran' }
    ])
    // Get Data
    this.get()
  },

}
</script>

<style lang="scss" src="@/assets/sass/pages/_expense-entry-page.scss"></style>
